{
  "summary": "Résumé",
  "linkToArticle": "Lien vers l'article",
  "title": "Titre",
  "remove": "Retirer",
  "imageOptional": "Image (facultatif)",
  "articleConfiguration": "Configuration de l'article",
  "status": "Statut",
  "articleLink": "Lien vers l'article",
  "lastUpdated": "Dernière mise à jour",
  "uploadedBy": "Téléversé par",
  "articleName": "Nom de l'article",
  "filter": "Filtre",
  "state": "État",
  "clearFilter": "Effacer le filtre",
  "applyFilter": "Appliquer le filtre",
  "active": "Actif",
  "inactive": "Inactif",
  "draft": "Brouillon",
  "paginatedView": "Afficher 1 - 3 sur {{totalCount}}",
  "errorStateMessage": "Le champ ne peut pas rester vide",
  "errorUrlStateMessage": "Le champ doit être une URL valide",
  "cancel": "Annuler",
  "confirm": "Confirmer",
  "deleteArticle": "Supprimer l'article d'actualité",
  "deleteArticleMessage": "Voulez vraiment supprimer cet article d'actualité? Une fois supprimé, le contenu sera définitivement effacé et ne pourra pas être récupéré."
}
